const insightUsers = {
  en: {
    insight_users: {
      title: 'Insight Users',
      media_eye_title: 'Media Eye Users',
      search_placeholder: 'Email or full name',
      update_results: 'Update Results',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      clients: 'Clients',
      projects: 'Projects',
      filter_selected_count: '{count} / {max}',
      confirmed: 'Confirmed',
      newsletter: 'Newsletter',
      iso_time_zone: 'Time zone',
      yes: 'Yes',
      no: 'No',
      name: 'Name',
      email: 'Email',
      admin: 'Admin',
      confirmed_badge: 'Confirmed',
      export: 'Export',
      export_csv: 'Export CSV',
      export_excel: 'Export Excel',
      export_empty: 'No users to export.',
      invite: 'Invite',
      invite_confirm: 'You will send an invite to {count} people. Confirm?',
      invites_sent: 'Successfully invited users',
      actions: {
        export: 'Export',
        invite: 'Invite'
      },
      delete: 'Delete',
      reorder_project: 'Reorder project',
      delete_confirm: 'This will permanently delete user {name}. Do you want to continue?',
      delete_success: 'User deleted successfully',
      login_as: 'Login to Insight',
      login_as_tooltip: 'Log in to Insight as {name}',
      no_users: 'No users match the current filters.',
      save: 'Save',
      first_name: 'First Name',
      last_name: 'Last Name',
      language: 'Newsletter header & footer language',
      language_en: 'English',
      language_fr: 'French',
      resend_invite: 'Resend Invite',
      mfa_enabled: 'Require 2FA',
      reset_password: 'Reset Password',
      password: 'New Password',
      confirm_password: 'Confirm New Password',
      password_hint: 'This will set a new password for this user. It must be Strong or Very Strong.',
      add_project: 'Projects',
      organization: 'Organization',
      project: 'Project',
      add: 'Add',
      email_digest: 'Daily Newsletter',
      group_by: 'Group by',
      group_by_media_type: 'Media Type',
      group_by_country: 'Country',
      group_by_language: 'Language',
      group_by_tags: 'Tags',
      group_by_none: 'None',
      alerts: 'Alerts',
      project_admin: 'Project Admin',
      add_digest: 'Add digest time',
      send_at: 'Send at',
      invited_by: 'Invited by {name} at {at}',
      invited_by_no_date: 'Invited by {name}',
      errors: {
        actor_email_not_carma: 'Login as requires a @carma.com email address.',
        too_many_attempts: 'Too many login attempts. Please try again later.',
        no_account_to_log_in: 'No Insight account found for this user.',
        login_as_failed: 'Unable to start Insight login.',
        max_digests_exceeded: 'A project can have at most 4 digest times.',
        invalid_send_at: 'Digest time must be HH:MM.',
        digest_user_not_found: 'No Insight account found for this user.',
        digest_update_failed: 'Unable to update digest times.',
        invite_not_sent: 'Unable to send the invite. Please try again.',
      },
    }
  }
};

module.exports.insightUsers = insightUsers;
